import { DynamicFormProps, ExpandedJSONSchema7 } from "am-tax-fe-core";
import { JSONSchemaType } from "ajv";

export type QuesSchemaType = {
    version: string;
    sections: QuesSectionType[];
};

export type QuesSectionType = {
    name: string;
    props: DynamicFormProps;
};

const generalSchema: ExpandedJSONSchema7 = {
    type: "object",
    schemaRenderOrder: ["q1", "q2", "q3", "q4", "q5"],
    properties: {
        q1: {
            type: "string",
            title: "Client Name",
            flexStyle: "1 0 100%",
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    q1: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q1"],
            },
            then: {
                properties: {
                    q3: {
                        type: "string",
                        title: "Client Abbreviation",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q2: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q2"],
            },
            then: {
                properties: {
                    q3: {
                        type: "string",
                        title: "Entity Legal Names",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q3: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q3"],
            },
            then: {
                properties: {
                    q4: {
                        type: "string",
                        title: "Entity Abbreviations",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q4: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q4"],
            },
            then: {
                properties: {
                    q5: {
                        type: "string",
                        title: "Entity Jurisdictions",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
    ],
    additionalProperties: true,
};

const transactionSchema: ExpandedJSONSchema7 = {
    type: "object",
    schemaRenderOrder: ["q6", "q7", "q8", "q9", "q10", "q11", "q12", "q13", "q14"],
    properties: {
        q6: {
            type: "string",
            title: "Total Transactions (Enter a number between 1 and 20)",
            flexStyle: "1 0 100%",
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    q6: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q6"],
            },
            then: {
                properties: {
                    q7: {
                        title: "Transaction Category",
                        type: "string",
                        format: "select",
                        enum: ["Goods", "Services", "IP"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q7: {
                        const: "Goods",
                    },
                },
                required: ["q7"],
            },
            then: {
                properties: {
                    q8: {
                        title: "Transaction Type",
                        type: "string",
                        format: "select",
                        enum: ["Manufacturing", "Distribution", "Procurement"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q7: {
                        const: "Services",
                    },
                },
                required: ["q7"],
            },
            then: {
                properties: {
                    q8: {
                        title: "Transaction Type",
                        type: "string",
                        format: "select",
                        enum: [
                            "Research and Development",
                            "Engineering",
                            "Sales and Marketing",
                            "Management and Administrative Support",
                            "Strategic Management",
                            "IT / Technology",
                            "Software Development",
                            "Other",
                        ],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q7: {
                        const: "IP",
                    },
                },
                required: ["q7"],
            },
            then: {
                properties: {
                    q8: {
                        title: "Transaction Type",
                        type: "string",
                        format: "select",
                        enum: ["Product/Technology", "Brand/Trademark", "Knowledge/Processes", "Other"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q8: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q8"],
            },
            then: {
                properties: {
                    q9: {
                        title: "Service Recipient / Licensor / Principal",
                        type: "string",
                        format: "select",
                        enum: ["Entity A", "Entity B", "Entity C", "Unspecified"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q9: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q9"],
            },
            then: {
                properties: {
                    q10: {
                        title: "Service Provider / Licensee / Distributor",
                        type: "string",
                        format: "select",
                        enum: ["Entity A", "Entity B", "Entity C", "Unspecified"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q7: {
                        const: "Goods",
                    },
                    q10: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q7"],
            },
            then: {
                properties: {
                    q11: {
                        title: "Method Selected",
                        type: "string",
                        format: "select",
                        enum: ["CUP", "Resale Margin", "Cost Plus", "CPM", "Profit Split", "Unspecified"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q7: {
                        const: "Services",
                    },
                    q10: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q7", "q10"],
            },
            then: {
                properties: {
                    q11: {
                        title: "Method Selected",
                        type: "string",
                        format: "select",
                        enum: ["CUP", "Resale Margin", "Cost Plus", "CPM", "Profit Split", "Unspecified"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q7: {
                        const: "IP",
                    },
                    q10: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q7", "q10"],
            },
            then: {
                properties: {
                    q11: {
                        title: "Method Selected",
                        type: "string",
                        format: "select",
                        enum: ["CUT", "CPM", "Profit Split", "SCM"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q11: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q11"],
            },
            then: {
                properties: {
                    q12: {
                        title: "Tested Party",
                        type: "string",
                        format: "select",
                        enum: ["Entity A", "Entity B", "Entity C", "Unspecified"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q12: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q12"],
            },
            then: {
                properties: {
                    q13: {
                        title: "PLI",
                        type: "string",
                        format: "select",
                        enum: ["OM", "MOTC", "ROA", "Berry Ratio", "Gross Margin"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q13: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q13"],
            },
            then: {
                properties: {
                    q14: {
                        type: "string",
                        title: "Benchmarking Set",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
    ],
    additionalProperties: true,
};

const reportCreationSchema: ExpandedJSONSchema7 = {
    type: "object",
    schemaRenderOrder: ["q15", "q16", "q17", "q18", "q19", "q20", "q21", "q21a", "q22", "q22a"],
    properties: {
        q15: {
            title: "Type of Report",
            type: "string",
            format: "select",
            enum: ["US Documentation", "OECD Local File", "OECD Master File", "Planning Report", "Benchmark Memorandum", "Other local country report"],
            isRequired: true,
            errorMessage: {
                enum: "Required",
            },
            flexStyle: "1 0 100%",
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    q15: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q15"],
            },
            then: {
                properties: {
                    q16: {
                        title: "Country",
                        type: "string",
                        format: "select",
                        enum: [
                            "Afghanistan",
                            "Albania",
                            "Algeria",
                            "Andorra",
                            "Angola",
                            "Antigua and Barbuda",
                            "Argentina",
                            "Armenia",
                            "Australia",
                            "Austria",
                            "Azerbaijan",
                            "Bahamas",
                            "Bahrain",
                            "Bangladesh",
                            "Barbados",
                            "Belarus",
                            "Belgium",
                            "Belize",
                            "Benin",
                            "Bhutan",
                            "Bolivia",
                            "Bosnia and Herzegovina",
                            "Botswana",
                            "Brazil",
                            "Brunei",
                            "Bulgaria",
                            "Burkina Faso",
                            "Burundi",
                            "Cabo Verde",
                            "Cambodia",
                            "Cameroon",
                            "Canada",
                            "Central African Republic",
                            "Chad",
                            "Chile",
                            "China",
                            "Colombia",
                            "Comoros",
                            "Congo (Congo-Brazzaville)",
                            "Costa Rica",
                            "Croatia",
                            "Cuba",
                            "Cyprus",
                            "Czechia (Czech Republic)",
                            "Democratic Republic of the Congo",
                            "Denmark",
                            "Djibouti",
                            "Dominica",
                            "Dominican Republic",
                            "Ecuador",
                            "Egypt",
                            "El Salvador",
                            "Equatorial Guinea",
                            "Eritrea",
                            "Estonia",
                            "Eswatini (fmr. Swaziland)",
                            "Ethiopia",
                            "Fiji",
                            "Finland",
                            "France",
                            "Gabon",
                            "Gambia",
                            "Georgia",
                            "Germany",
                            "Ghana",
                            "Greece",
                            "Grenada",
                            "Guatemala",
                            "Guinea",
                            "Guinea-Bissau",
                            "Guyana",
                            "Haiti",
                            "Honduras",
                            "Hungary",
                            "Iceland",
                            "India",
                            "Indonesia",
                            "Iran",
                            "Iraq",
                            "Ireland",
                            "Israel",
                            "Italy",
                            "Jamaica",
                            "Japan",
                            "Jordan",
                            "Kazakhstan",
                            "Kenya",
                            "Kiribati",
                            "Kuwait",
                            "Kyrgyzstan",
                            "Laos",
                            "Latvia",
                            "Lebanon",
                            "Lesotho",
                            "Liberia",
                            "Libya",
                            "Liechtenstein",
                            "Lithuania",
                            "Luxembourg",
                            "Madagascar",
                            "Malawi",
                            "Malaysia",
                            "Maldives",
                            "Mali",
                            "Malta",
                            "Marshall Islands",
                            "Mauritania",
                            "Mauritius",
                            "Mexico",
                            "Micronesia",
                            "Moldova",
                            "Monaco",
                            "Mongolia",
                            "Montenegro",
                            "Morocco",
                            "Mozambique",
                            "Myanmar (formerly Burma)",
                            "Namibia",
                            "Nauru",
                            "Nepal",
                            "Netherlands",
                            "New Zealand",
                            "Nicaragua",
                            "Niger",
                            "Nigeria",
                            "North Korea",
                            "North Macedonia",
                            "Norway",
                            "Oman",
                            "Pakistan",
                            "Palau",
                            "Palestine State",
                            "Panama",
                            "Papua New Guinea",
                            "Paraguay",
                            "Peru",
                            "Philippines",
                            "Poland",
                            "Portugal",
                            "Qatar",
                            "Romania",
                            "Russia",
                            "Rwanda",
                            "Saint Kitts and Nevis",
                            "Saint Lucia",
                            "Saint Vincent and the Grenadines",
                            "Samoa",
                            "San Marino",
                            "Sao Tome and Principe",
                            "Saudi Arabia",
                            "Senegal",
                            "Serbia",
                            "Seychelles",
                            "Sierra Leone",
                            "Singapore",
                            "Slovakia",
                            "Slovenia",
                            "Solomon Islands",
                            "Somalia",
                            "South Africa",
                            "South Korea",
                            "South Sudan",
                            "Spain",
                            "Sri Lanka",
                            "Sudan",
                            "Suriname",
                            "Sweden",
                            "Switzerland",
                            "Syria",
                            "Tajikistan",
                            "Tanzania",
                            "Thailand",
                            "Timor-Leste",
                            "Togo",
                            "Tonga",
                            "Trinidad and Tobago",
                            "Tunisia",
                            "Turkey",
                            "Turkmenistan",
                            "Tuvalu",
                            "Uganda",
                            "Ukraine",
                            "United Arab Emirates",
                            "United Kingdom",
                            "United States of America",
                            "Uruguay",
                            "Uzbekistan",
                            "Vanuatu",
                            "Vatican City",
                            "Venezuela",
                            "Vietnam",
                            "Yemen",
                            "Zambia",
                            "Zimbabwe",
                        ],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q16: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q16"],
            },
            then: {
                properties: {
                    q17: {
                        title: "Year of Report",
                        type: "string",
                        format: "select",
                        enum: Array.from({ length: 2050 - 2018 + 1 }, (_, i) => (2018 + i).toString()),
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q17: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q17"],
            },
            then: {
                properties: {
                    q18: {
                        title: "Tax Year End",
                        type: "string",
                        format: "date",
                        isRequired: true,
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q18: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q18"],
            },
            then: {
                properties: {
                    q19: {
                        title: "Primary Entity",
                        type: "string",
                        format: "select",
                        enum: ["Entity A", "Entity B", "Entity C", "Unspecified"],
                        isRequired: true,
                        errorMessage: {
                            enum: "Required",
                        },
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q19: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q19"],
            },
            then: {
                properties: {
                    q20: {
                        type: "string",
                        title: "Competitors",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q20: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q20"],
            },
            then: {
                properties: {
                    q21: {
                        type: "string",
                        title: "Did the entity undertake any business acquisitions during the year?",
                        format: "buttonGroup",
                        enum: ["Yes", "No"],
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q21: {
                        const: "Yes",
                    },
                },
                required: ["q21"],
            },
            then: {
                properties: {
                    q21a: {
                        type: "string",
                        title: "Description of Acquisitions",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q21: {
                        const: "No",
                    },
                },
                required: ["q21"],
            },
            then: {
                properties: {
                    q22: {
                        type: "string",
                        title: "Did the entity undertake any restructuring transactions and divestitures during the year?",
                        format: "buttonGroup",
                        enum: ["Yes", "No"],
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q21a: {
                        type: "string",
                        minLength: 1,
                    },
                },
                required: ["q21a"],
            },
            then: {
                properties: {
                    q22: {
                        type: "string",
                        title: "Did the entity undertake any restructuring transactions and divestitures during the year?",
                        format: "buttonGroup",
                        enum: ["Yes", "No"],
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    q22: {
                        const: "Yes",
                    },
                },
                required: ["q22"],
            },
            then: {
                properties: {
                    q22a: {
                        type: "string",
                        title: "Description of Divestitures",
                        flexStyle: "1 0 100%",
                    },
                },
            },
        },
    ],
    additionalProperties: true,
};

const questionnaireGeneralProps: DynamicFormProps = {
    hideActions: true,
    formSchema: generalSchema as JSONSchemaType<ExpandedJSONSchema7>,
};

const questionnaireGeneral: QuesSectionType = {
    name: "General",
    props: questionnaireGeneralProps,
};

const questionnaireTransactionProps: DynamicFormProps = {
    hideActions: true,
    formSchema: transactionSchema as JSONSchemaType<ExpandedJSONSchema7>,
};

const questionnaireTransaction: QuesSectionType = {
    name: "Transaction",
    props: questionnaireTransactionProps,
};

const questionnaireReportProps: DynamicFormProps = {
    hideActions: true,
    formSchema: reportCreationSchema as JSONSchemaType<ExpandedJSONSchema7>,
};

const questionnaireReport: QuesSectionType = {
    name: "Report",
    props: questionnaireReportProps,
};

export const surveySchema: QuesSchemaType = {
    version: "1.0",
    sections: [questionnaireGeneral, questionnaireTransaction, questionnaireReport],
};
